// components/shared/TermsOfService.jsx
import React from "react";

const TermsOfService = () => {
    return (
        <div className="min-h-screen bg-darkblue text-lightgray px-6 py-16">
            <div className="max-w-4xl mx-auto">
                <h1 className="text-4xl font-bold text-orange text-center mb-4">
                    Terms of Service
                </h1>
                <p className="text-center italic mb-8">Last updated: 3/20/2025</p>

                <div className="space-y-6 text-lg">
                    {/* 1. Introduction */}
                    <section>
                        <h2 className="text-2xl font-semibold text-orange mb-2">1. Introduction</h2>
                        <p>
                            Welcome to Career Mission ("Company", "we", "us", or "our"). These Terms of Service ("Terms") govern your access to and use of our website, products, and services ("Services"). By accessing or using our Services, you agree to be bound by these Terms. If you do not agree with these Terms, please do not use our Services.
                        </p>
                    </section>

                    {/* 2. Use of Our Services */}
                    <section>
                        <h2 className="text-2xl font-semibold text-orange mb-2">2. Use of Our Services</h2>
                        <p>
                            We grant you a limited, non-exclusive, non-transferable, and revocable license to use our Services for personal or internal business purposes, in accordance with these Terms. You agree not to misuse the Services or help others do so.
                        </p>
                    </section>

                    {/* 3. User Accounts */}
                    <section>
                        <h2 className="text-2xl font-semibold text-orange mb-2">3. User Accounts</h2>
                        <p>
                            If you create an account with us, you are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You agree to notify us immediately of any unauthorized use of your account. We reserve the right to suspend or terminate your account for violations of these Terms.
                        </p>
                    </section>

                    {/* 4. Intellectual Property */}
                    <section>
                        <h2 className="text-2xl font-semibold text-orange mb-2">4. Intellectual Property</h2>
                        <p>
                            All content, trademarks, and other intellectual property on our website are owned by us or our licensors. You agree not to reproduce, distribute, modify, or create derivative works from any of our content without our prior written consent.
                        </p>
                    </section>

                    {/* 5. User Content */}
                    <section>
                        <h2 className="text-2xl font-semibold text-orange mb-2">5. User Content</h2>
                        <p>
                            You may have the opportunity to submit or upload content to our Services. While you retain ownership of your content, by submitting it, you grant us a non-exclusive, worldwide, royalty-free license to use, display, and distribute your content for the purpose of providing our Services. You represent and warrant that you have all rights necessary to grant this license.
                        </p>
                    </section>

                    {/* 6. Disclaimers and Limitation of Liability */}
                    <section>
                        <h2 className="text-2xl font-semibold text-orange mb-2">6. Disclaimers and Limitation of Liability</h2>
                        <p>
                            Our Services are provided "as is" and "as available," without any warranties of any kind, either express or implied. We do not guarantee that our Services will be uninterrupted, error-free, or secure. In no event will Career Mission be liable for any direct, indirect, incidental, special, consequential, or punitive damages arising from your use or inability to use our Services.
                        </p>
                    </section>

                    {/* 7. Indemnification */}
                    <section>
                        <h2 className="text-2xl font-semibold text-orange mb-2">7. Indemnification</h2>
                        <p>
                            You agree to indemnify, defend, and hold harmless Career Mission, its officers, directors, employees, and agents from any claims, liabilities, damages, or expenses arising from your use of our Services, your violation of these Terms, or your infringement of any rights of a third party.
                        </p>
                    </section>

                    {/* 8. Modifications to These Terms */}
                    <section>
                        <h2 className="text-2xl font-semibold text-orange mb-2">8. Modifications to These Terms</h2>
                        <p>
                            We may update or modify these Terms from time to time. When we make material changes, we will update the "Last updated" date at the top of this page and provide notice by posting the updated Terms on our website. Your continued use of our Services after such changes constitutes your acceptance of the new Terms.
                        </p>
                    </section>

                    {/* 9. Governing Law */}
                    <section>
                        <h2 className="text-2xl font-semibold text-orange mb-2">9. Governing Law</h2>
                        <p>
                            These Terms shall be governed by and construed in accordance with the laws of the State of Indiana, without regard to its conflict of law principles.
                        </p>
                    </section>

                    {/* 10. Contact Us */}
                    <section>
                        <h2 className="text-2xl font-semibold text-orange mb-2">10. Contact Us</h2>
                        <p>
                            If you have any questions or concerns about these Terms, please contact us at:
                        </p>
                        <p className="text-lg font-semibold">
                            <a href="mailto:contact@careermission.ai" className="text-lightblue hover:underline">
                                contact@careermission.ai
                            </a>
                        </p>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default TermsOfService;
